import { render, staticRenderFns } from "./HomeNavChild.vue?vue&type=template&id=1a5bb6dd&scoped=true"
import script from "./HomeNavChild.vue?vue&type=script&lang=js"
export * from "./HomeNavChild.vue?vue&type=script&lang=js"
import style0 from "./HomeNavChild.vue?vue&type=style&index=0&id=1a5bb6dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5bb6dd",
  null
  
)

export default component.exports